import {makeAutoObservable} from 'mobx';
import MicrolessonsRepository from '../../../../data/repositories/MicrolessonsRepository';

class MicrolessonEditorStore {
  private microlessonsRepo = new MicrolessonsRepository();

  constructor() {
    makeAutoObservable(this);
  }

  public async getMicrolessonById(organizationId: string, lessonId: string) {
    const result = await this.microlessonsRepo.getMicrolessonById(
      organizationId,
      lessonId,
    );
    if (result.success && result.data) {
      return result.data;
    }
  }
}

export default MicrolessonEditorStore;
